/** @format */
import { css } from 'styled-components';

import {
    largeTablet,
    mobile,
    smallTablet,
} from '@toucan/client/global/application';

const baseStyles = css`
    padding: var(--layout-spacing-48) 0;
    overflow: hidden;

    .carousel-wrapper {
        position: relative;
        display: flex;
        padding: 0 0 var(--layout-spacing-12);
    }

    .article-tile {
        flex-shrink: 0;
        margin-right: var(--layout-spacing-24);
        touch-action: none;
        cursor: grab;
    }

    .carousel-chrome {
        display: grid;
        column-gap: 2.4rem;
        grid-template-areas: 'pretitle .' 'title controls';
        grid-template-columns: 1fr 8rem;

        h3 {
            grid-area: title;
        }

        small {
            grid-area: pretitle;
        }
    }

    .carousel-title {
        display: contents;
    }

    .carousel-controls {
        display: flex;
        flex-grow: 0;
        grid-area: controls;
        gap: var(--layout-spacing-8);
        justify-content: flex-end;
        align-items: center;
    }

    img {
        pointer-events: none;
    }

    ${largeTablet(css`
        padding: var(--layout-spacing-24) 0;
    `)}

    ${mobile(css`
        padding: var(--layout-spacing-12) 0;
    `)}
`;

const skeletonStyles = css`
    .carousel-controls .skeleton {
        width: 3.2rem;
        height: 3.2rem;
    }

    .carousel-pretitle .skeleton {
        width: 10%;
    }

    .carousel-title .skeleton {
        width: 25%;
    }

    ${smallTablet(css`
        .carousel-pretitle .skeleton {
            width: 15%;
        }

        .carousel-title .skeleton {
            width: 50%;
        }
    `)};
`;

export const styles = () => css`
    ${baseStyles}
    ${skeletonStyles}
`;
